import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NgClass, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'ama-ng-app-store-cell-badge',
  template: `
    <span class="badge rounded-pill me-2"
          [ngClass]="valueToClass[value]">
      {{ value | titlecase }}
    </span>`,
  standalone: true,
  imports: [TitleCasePipe, NgClass],
})
export class AgGridBadgeComponent implements ICellRendererAngularComp {
  @ViewChild('container') container?: ElementRef;

  value = '';
  protected valueToClass: { [key: string]: string } = {};

  agInit(params: ICellRendererParams & { badgeMap: { [key: string]: string }}): void {
    this.value = params.value;
    this.valueToClass = params.badgeMap;
  }

  refresh(_: ICellRendererParams): boolean {
    return false;
  }
}
